import { Component, OnInit } from '@angular/core';
import { StarRatingComponent } from '@spartacus/storefront';
import { ICON_TYPE } from '../../../../../custom/icons/icon.model';

@Component({
  selector: 'app-custom-star-rating',
  templateUrl: './custom-star-rating.component.html',
  styleUrls: ['./custom-star-rating.component.scss'],
  standalone: false
})
export class CustomStarRatingComponent extends StarRatingComponent {
  iconTypes = ICON_TYPE;

}
